import React from 'react';
import { TA, HZNU_logo, YNU, ynvtc, YUNNAN, putra, UUM, UITM, TNI_logo, msu, AIT, AIS, cambridgeInternationalCollege, State_University_of_New_York_seal, UniMAP, Frank, Salford, worcester } from '../static'

const InternationalCollaboration = () => {
    return (
        <div className='internationalHome'>
            <p className='heading3 text-left'>International Academic Collaborations</p>


            <div className="listOfIntnationIns">
                <div className="card">
                    <a href="http://www.worcester.ac.uk/">
                        <img src={worcester}
                            className="card-img-top rounded" alt="University of Worcester. UK" /></a>
                </div>
                {/* <div className="card">
                    <a href="http://www.londonpremiercollege.com/">
                        <img src={LPC}
                            className="card-img-top rounded" alt="London Premier College (London University, UK)" /></a>

                </div> */}
                <div className="card">
                    <a href="http://www.salford.ac.uk/">
                        <img src={Salford}
                            className="card-img-top rounded" alt="University of Salford, Manchester" /></a>

                </div>
                <div className="card">
                    <a href="http://www.franklin.edu/">
                        <img src={Frank}
                            className="card-img-top rounded" alt="Franklin University, Ohio, USA" /></a>

                </div>
                <div className="card">
                    <a href="http://www.unimap.edu.my/">
                        <img src={UniMAP}
                            className="card-img-top rounded" alt="University Malaysis Peris (UniMAP), Malaysia" /></a>

                </div>
                <div className="card">
                    <a href="https://www.suny.edu/">
                        <img src={State_University_of_New_York_seal}
                            className="card-img-top rounded" alt="State University of New York (SUNY)" /></a>

                </div>
                <div className="card">
                    <a href="http://www.cambridgecollege.co.uk/">
                        <img src={cambridgeInternationalCollege}
                            className="card-img-top rounded" alt="Cambridge International College" /></a>

                </div>
                <div className="card">
                    <a href="http://www.ais.ac.nz/">
                        <img src={AIS}
                            className="card-img-top rounded" alt="Auckland Institute of Studies (AIS), St Helens, Auckland, New Zealand" /></a>

                </div>
                <div className="card">
                    <a href="http://www.ait.ac.th/">
                        <img src={AIT}
                            className="card-img-top rounded" alt="Asian
                                    Institute of Technology" /></a>

                </div>
                <div className="card">
                    <a href="http://www.msu.edu.my">
                        <img src={msu}
                            className="card-img-top rounded" alt="Management
                                    &amp; Science University, Malaysia" /></a>

                </div>

                <div className="card">
                    <a href="http://www.tni.ac.th/web/tni2014-en/">
                        <img src={TNI_logo}
                            className="card-img-top rounded" alt="Thai-Nichi Institute of Technology" /></a>

                </div>

                <div className="card">
                    <a href="http://www.uitm.edu.my/index.php/en/">
                        <img src={UITM}
                            className="card-img-top rounded" alt="Universiti Teknologi MARA (UiTM)" /></a>

                </div>

                <div className="card">
                    <a href="http://www.uum.edu.my/index.php/en/">
                        <img src={UUM}
                            className="card-img-top rounded" alt="University Utara Malaysia" /></a>

                </div>

                <div className="card">
                    <a href="http://putrabusinessschool.edu.my/">
                        <img src={putra}
                            className="card-img-top rounded" alt="Putra Business School" /></a>

                </div>

                <div className="card">
                    <a href="http://en.ynufe.edu.cn/">
                        <img src={YUNNAN}
                            className="card-img-top rounded" alt="Yunnan University of Finance and Economics, (YUFE)" /></a>

                </div>

                <div className="card">
                    <a href="http://school.cuecc.com/Yunnan/ynou/index.html">
                        <img src={ynvtc}
                            className="card-img-top rounded" alt="Yunnan Open University (YNOU)" /></a>

                </div>

                <div className="card">
                    <a href="http://english.ynnu.edu.cn/">
                        <img src={YNU}
                            className="card-img-top rounded" alt="Yunnan Normal University, China (YNNU)" /></a>

                </div>

                <div className="card">
                    <a href="http://www.csc.edu.cn/studyinchina/indexen.aspx">
                        <img src={HZNU_logo}
                            className="card-img-top rounded" alt="Hangzhou Normal
                                    University" /></a>

                </div>

                <div className="card">
                    <a href="http://www.tamk.fi/en">
                        <img src={TA}
                            className="card-img-top rounded" alt="Tampere University of Applied Science, Finland" /></a>

                </div>

            </div>
        </div>
    );
};

export default InternationalCollaboration;